export default "__VITE_ASSET__DsMA3lvB__"